import script from "/home/d/dev/unolet/unolet/frontend/src/ts/vue/components/TableHeaderSort.vue?type=script"
export * from "/home/d/dev/unolet/unolet/frontend/src/ts/vue/components/TableHeaderSort.vue?type=script"
export default script